/**
 *  @class
 *  @function Pagination
 */

if (!customElements.get('pagination')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector('.load-more');
      this.grid = document.querySelector('[data-id=' + id + ']');
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      // Start with the page after the one that was rendered, and remember how
      // many pages exist so nothing is requested past the last page (pages
      // beyond the end return products that are already in the grid).
      this.i = (parseInt(this.dataset.currentPage, 10) || 1) + 1;
      this.pages = parseInt(this.dataset.pages, 10) || 0;
      this.page_size = this.dataset.pageSize;
    }
    connectedCallback() {
      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }
      if (this.isLastPage()) {
        this.finish();
      }
    }
    isLastPage() {
      return this.pages > 0 && this.i > this.pages;
    }
    addUrlParam(search, key) {
      var newParam = key + '=' + this.i,
        params = '?' + newParam;

      // If the "search" string exists, then build params from it
      if (search) {
        // Try to replace an existance instance
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);

        // If nothing was replaced, then add the new param to the end
        if (params === search) {
          params += '&' + newParam;
        }
      }

      return params;
    }
    loadMore() {
      let base = this;
      this.button.addEventListener('click', function () {
        base.loadProducts();
        this.blur();
        return false;
      });
    }
    infinite() {
      let base = this;
      base.observer = new IntersectionObserver(function (entries) {
        if (entries[0].intersectionRatio === 1) {
          base.loadProducts();
        }
      }, {
        threshold: [0, 1]
      });
      base.observer.observe(base);
    }
    loadProducts() {
      let base = this;
      if (base.getAttribute('loading')) {
        return;
      }
      if (base.isLastPage()) {
        base.finish();
        return;
      }
      let url = document.location.pathname + base.addUrlParam(document.location.search, 'page');
      base.i++;
      base.setAttribute('loading', true);
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;
          base.renderProducts(html, url);

          dispatchCustomEvent('pagination:page-changed', {
            url: url
          });
        });
    }
    renderProducts(html, url) {
      let base = this,
        grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');

      if (!grid_to_replace) {
        base.removeAttribute('loading');
        base.finish();
        if (base.button) {
          base.button.classList.add('visually-hidden');
        }
        return;
      }
      let products = grid_to_replace.querySelectorAll('.column');

      const appendProducts = () => {
        products.forEach((product) => {
          this.grid.appendChild(product);
          product.querySelectorAll('.lazyload').forEach((image) => {
            lazySizes.loader.unveil(image);
          });
        });
      };

      if (this.animations_enabled) {
        // GSAP staggers the new items in — a view transition on top
        // would snapshot them pre-animation and flicker. Append directly.
        appendProducts();
        gsap.set(products, {
          opacity: 0,
          y: 30
        });
        gsap.to(products, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05,
          onComplete: function () {
            base.removeAttribute('loading');
          }
        });
      } else {
        withViewTransition(appendProducts);
        base.removeAttribute('loading');
        if (typeof StampedFn.loadBadges !== "undefined") {
          StampedFn.loadBadges();
        }
      }
      if (this.pages > 0) {
        if (this.isLastPage()) {
          this.finish();
        }
      } else if (products.length < this.page_size) {
        this.finish();
      }
    }
    finish() {
      if (this.observer) {
        this.observer.unobserve(this);
      }
      this.hide();
    }
    hide() {
      if (this.button) {
        this.button.style.display = 'none';
      }
    }
  }
  customElements.define('pagination-theme', Pagination);
}
